import { ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
import { ModuleFE_Advisor_ContextRule, ModuleFE_Advisor_Variable } from '@app/advisor-frontend';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
export const getFindingsInContext = (context) => {
    const findings = ModuleFE_RuntimeFinding.getLatestFindings(false, true);
    return findings.filter(finding => {
        const variable = ModuleFE_Advisor_Variable.cache.unique(finding.variableId);
        if (!variable)
            throw new MUSTNeverHappenException(`Could not get variable for id ${finding.variableId}`);
        return ModuleFE_Advisor_ContextRule.variablePassesRule(context, variable);
    });
};
//# sourceMappingURL=get-findings-in-context.js.map